import { MarketingLayout } from "@/components/MarketingLayout";
import { Seo } from "@/components/Seo";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  ["Is KREONIS a broker?", "No. KREONIS is a market-intelligence, analysis and education platform. We do not custody funds or execute real-money trades. Paper trading uses simulated money only."],
  ["Are the prices real?", "In this version all market data is clearly labelled DEMO and generated by our engine. The architecture is modular so live market-data providers can be connected later without rebuilding the app."],
  ["Do you guarantee profits?", "Never. AI signals are informational and probabilistic. Confidence scores are analytical estimates, not guarantees of profit. Trading involves significant risk of loss."],
  ["What does the confidence score mean?", "It is a 0–100 analytical score reflecting how well multiple factors (trend, momentum, multi-timeframe alignment, volatility) align — not a probability of profit."],
  ["Do you hide losing signals?", "No. Our transparency page shows all published signals including losing and expired ones, with full analytics by market and timeframe."],
  ["What's included in the free plan?", "Limited AI signals, basic market analysis, a basic watchlist, paper trading and basic Academy access. Pro and Premium unlock more signals, backtesting, advanced alerts and AI tools."],
  ["Is there a trial?", "Yes — the Pro plan includes a configurable 7-day free trial."],
  ["How is my data secured?", "Passwords are hashed with bcrypt, sessions use signed JWTs in httpOnly cookies, and API keys stay strictly server-side."],
];

export default function FAQ() {
  return (
    <MarketingLayout>
      <Seo title="FAQ" description="Frequently asked questions about KREONIS." />
      <div className="mx-auto max-w-3xl px-4 py-14 sm:px-6">
        <span className="text-xs font-semibold uppercase tracking-widest text-accent">FAQ</span>
        <h1 className="mt-2 font-display text-3xl font-bold tracking-tight sm:text-4xl">Frequently asked questions</h1>
        <Accordion type="single" collapsible className="mt-8" data-testid="faq-accordion">
          {faqs.map(([q, a], i) => (
            <AccordionItem key={i} value={`item-${i}`}>
              <AccordionTrigger className="text-left font-display">{q}</AccordionTrigger>
              <AccordionContent className="text-muted-foreground">{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </MarketingLayout>
  );
}
